import './_SectionTitle.scss'

/**
 * @component SectionTitle
 * @param {object} params 
 * @param {string} params.title 
 * @param {string} params.text
 * @param {boolean} params.sm - Small text 16px
 */

const SectionTitle = ({ title, text, sm }) => {
  return (
    <div className='SectionTitle'>
      <span className='SectionTitle__line'></span>
      <h2 className='SectionTitle__title'>{title}</h2>
      <p className={`SectionTitle__text ${sm ? 'sm' : ''}`}>{text}</p>
    </div>
  )
}


export default SectionTitle
